import React from 'react';
import './AddPower.scss';

function AddPower(props) {
  const {
    view,
    showPowerOptionsFn,
    showPowerOptions,
    title,
    btnText,
    setIsEditable,
    userInfo,
    canUpdatePower,
    dataLocale,
    lensType,
    listing,
    setIsEditPowerFlow,
    isHTO = false,
    orderId,
  } = props;
  const clickHandlerFn = () => {
    if(isHTO) {
      if (window && window.location.hostname === 'localhost') {
        window.location.assign(`http://preprod.lenskart.com/HTO/repeat?bookingType=onlineEyeTest&onlineOrderId=${orderId}`);
      } else {
        const currentDomain = window.location.origin;
        window.location.assign(`${currentDomain}/HTO/repeat?&bookingType=onlineEyeTest&onlineOrderId=${orderId}`);
      }
    } else {
      const trackEnv = view === 'desktop' ? 'dtm' : 'mobileGA';
      const dlUpdate = {
        event: 'cta_click',
        cta_flow_and_page: listing ? 'post-purchase-order-listing' : 'post-purchase-order-detail',
        cta_name: canUpdatePower ? 'edit-power' : 'add-power',
        customer_id: userInfo?.id,
        lk_user_type: userInfo?.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
        pp_prescription_type: lensType?.toLowerCase(),
      };
      if (typeof window.dataLayer !== 'undefined') window.dataLayer?.push(dlUpdate);
      else {
        setTimeout(() => {
          window.dataLayer?.push(dlUpdate);
        }, 2000);
      }
      if (canUpdatePower) setIsEditable(true);
      if (window[trackEnv].LenskartRewamp) {
        window[trackEnv].LenskartRewamp.myaccount?.myOrderStatusEventsClick(listing, 'add power');
      }
      if (view !== 'desktop') setIsEditPowerFlow(false);
      showPowerOptionsFn();
    }
  };
  return (
    <div
      className={`addPower display-flex justify-space-between ${view === 'desktop'
          ? 'padding-15 margin-b10 margin-t10 margin-l15 margin-r15 bora-8'
          : 'pd-12 mr-l10 mr-r10 mr-t5 bora-4'
        }`}
    >
      <div className={`${view === 'desktop' ? 'align-self-center fs14' : ''}`}>
        {canUpdatePower ? dataLocale?.CHANGE_IN_POWER : title}
      </div>
      <div
        className="addPower-btn fw700 fs14 cursor-pointer lh-16 text-uppercase"
        onClick={clickHandlerFn}
      >
        {canUpdatePower ? dataLocale?.EDIT_POWER : btnText}
        {view === 'desktop' && (
          <span
            className={`${showPowerOptions ? 'fa fa-angle-up' : 'fa fa-angle-down'
              } padding-l10 fs20 text-color-primary cursor-pointer fw700`}
          />
        )}
      </div>
    </div>
  );
}

export default AddPower;
